// Layout de "2 consultas por página" — 028A (página de atención) y 028C
// (Serie 028, Fase 2) son los únicos formularios del Anexo 1 MSP con este
// formato (columnas Consulta 1 / Consulta 2, cada una con su propio estado
// completo). No hay precedente en el repo — se construye acá una sola vez al
// implementar 028A y se reusa tal cual en 028C.
import type { JSX, ReactNode } from 'react';

export const GRID_DOS_CONSULTAS = 'grid grid-cols-1 gap-4 md:grid-cols-2';

export interface ConsultaCardProps {
  readonly titulo: string;
  readonly children: ReactNode;
}

export function ConsultaCard({ titulo, children }: ConsultaCardProps): JSX.Element {
  return (
    <div className="flex flex-col gap-4 rounded-md border border-border p-3">
      <h4 className="text-sm font-medium text-hce-ink">{titulo}</h4>
      {children}
    </div>
  );
}
